import { ApiConfig } from "../../../../common/models";

export const tagLibraryConfig = {
  getAllTagLibraries: (): ApiConfig => ({
    url: `/api/tagLibrary/get-all`,
    method: "GET"
  })
};
